import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import workerSrc from 'pdfjs-dist/build/pdf.worker.entry';
import './style.css';

GlobalWorkerOptions.workerSrc = workerSrc;

function CompressPdfModal({ onClose }) {
  const [compressedPdfUrl, setCompressedPdfUrl] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progressText, setProgressText] = useState('');

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsProcessing(true);
    setProgressText('Lendo arquivo PDF...');
    const fileReader = new FileReader();

    fileReader.onload = async () => {
      const typedArray = new Uint8Array(fileReader.result);
      const loadingTask = pdfjsLib.getDocument({ data: typedArray });
      const pdf = await loadingTask.promise;
      const newPdf = await PDFDocument.create();

      for (let i = 0; i < pdf.numPages; i++) {
        setProgressText(`Comprimindo página ${i + 1} de ${pdf.numPages}...`);

        const page = await pdf.getPage(i + 1);
        const viewport = page.getViewport({ scale: 1.5 });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: context, viewport }).promise;

        const dataUrl = canvas.toDataURL('image/jpeg', 0.5);
        const imageBytes = await fetch(dataUrl).then(res => res.arrayBuffer());
        const embeddedJpg = await newPdf.embedJpg(imageBytes);

        const newPage = newPdf.addPage([viewport.width, viewport.height]);
        newPage.drawImage(embeddedJpg, {
          x: 0,
          y: 0,
          width: viewport.width,
          height: viewport.height,
        });
      }

      setProgressText('Gerando PDF final...');
      const pdfBytes = await newPdf.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setCompressedPdfUrl(url);
      setIsProcessing(false);
      setProgressText('Concluído!');
    };

    fileReader.readAsArrayBuffer(file);
  };

  return (
    <div className="modal-compress">
      <div className="compress-container">
        <h2 className="compress-title">Comprimir PDF</h2>
        <label className="custom-file-upload">
          Selecionar PDF
          <input type="file" accept="application/pdf" onChange={handleFileChange} />
        </label>


        {isProcessing && (
          <div className="compress-loader">
            <div className="spinner"></div>
            <p className="progress-text">{progressText}</p>
          </div>
        )}

        {compressedPdfUrl && !isProcessing && (
          <div className="download-container">
            <a className="download-button" href={compressedPdfUrl} download="compressed.pdf">
              Baixar PDF Comprimido
            </a>
          </div>
        )}

        <button className="close-button" onClick={onClose}>Fechar</button>
      </div>
    </div>
  );
}

export default CompressPdfModal;
